module.exports = __webpack_public_path__ + "img/vacuum.9cbe86b4.jpg";